import { signal } from '@angular/core';
import type { SchemaPathTree } from '@angular/forms/signals';
import { form } from '@angular/forms/signals';
import { signalStoreFeature, withProps } from '@ngrx/signals';

export type SignalFormSchemaFn<FormModel> = (
  path: SchemaPathTree<FormModel>
) => void;

/**
 * Adds a signal-backed Angular form (`formModel` + `entityForm`) to a Signal Store.
 *
 * @template FormModel The writable form model type.
 */
export function withSignalForm<FormModel>(config: {
  createEmptyValue: () => FormModel;
  schema: SignalFormSchemaFn<FormModel>;
}) {
  return signalStoreFeature(
    withProps(() => {
      const formModel = signal<FormModel>(config.createEmptyValue());
      const entityForm = form(formModel, config.schema);
      return { entityForm, formModel };
    })
  );
}
